// IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках — «когда мы ищем в таблице и в ячейках есть ссылочные типы —
// если результат не дал положительного, поискать по их тексту на других языках»): СТУПЕНЬ «НА ДРУГОМ ЯЗЫКЕ» ЧИПСА ПОИСКА ТАБЛИЦЫ.
// Грид ищет по ПОКАЗАННОМУ тексту ячеек; у ссылочной ячейки это название записи словаря (store.itemsSource[relation_segment].ids[id].title) на языке
// интерфейса. С 25.09 (ie-webscm7-2, BE bfcfbc695: get_itemsSource all / by_ids / name_search) строка словаря несёт ещё titles_alt — названия той же записи
// на ДРУГИХ языках (база, meta.title_{lang}, варианты DS), только когда они есть. Когда вся лестница поиска грида на показанных текстах (фраза → части →
// раскладка клавиатуры → ступени опечаток 1…6) не дала НИ ОДНОЙ строки, грид проходит ту же лестницу по titles_alt словарных элементов ссылочных ячеек
// (только колонки с relation_segment): строка видна, если каждая часть найдена хоть в какой-то её ячейке — в показанном тексте либо в названии на другом языке
// (предки в дереве — как у обычного поиска); счётчик / ‹ › ходят и по таким ячейкам; ячейка получает класс search-alt-hit (показанный текст не совпал —
// подсвечивать в нём нечего), совпавшее название — в подсказке ячейки строкой «Matched: <имя> (English)»; на чипсе — значок языка, в форме чипса — подпись
// «Matches in English names» (язык словами, если он один; иначе «other languages»). Ступень не идёт для чипса с местом Input (бэк ищет по всем языкам сам).
// Решение принимает грид (AttrGrid.searchAlt_decide: проходы по строкам данных), здесь — чистая логика без Vue: лестница, тексты, сопоставление, язык, подписи.
// Выключатель fe.ux.gridSearchOtherLangs (вкл.). Юнит — handoff-files/grid-search-2026-09-25/gridSearchAlt.test.mjs
import { searchTerms, fuzzyMaxTier, fuzzyFindTier, FUZZY_TIERS, searchPhrase, phraseFind } from './searchMatch'
import { layoutCandidates } from './keyboardLayout'
import { t, getLanguage } from '@/i18n'

export const ALT_LANG_OTHER = 'other'   // подпись «other languages»: совпавшие названия на разных языках либо язык не распознан
// IE 2026 09 28 / ODOO-341407 (Igor: для пользователя в Украине интерфейс не называет русский язык — «Збіги в російських назвах…» некорректно):
// язык, который подписи совпадений на других языках НЕ называют, — вместо него нейтральная «other languages» (чипс, форма чипса, подсказка
// ячейки, панели-меню); поведение поиска не меняется
export const ALT_LANG_UNNAMED = Object.freeze(['ru'])   // IE 2026 09 28 / ODOO-341407
export function gridSearchAlt_shownLang(lang) {   // IE 2026 09 28 / ODOO-341407: язык для подписи — en | uk | other
    const l = String(lang || '')
    return (!l || ALT_LANG_UNNAMED.includes(l)) ? ALT_LANG_OTHER : l
}
const RE_LAT = /[a-z]/i, RE_CYR = /[а-яёіїєґ]/i, RE_UK = /[іїєґ]/i, RE_RU = /[ыэъё]/i

// названия элемента словаря на других языках в НИЖНЕМ регистре — для отбора / счётчика / метки ячейки (проходы «строка × колонки»: без повторных
// toLowerCase на каждую ячейку). Кэш — по массиву titles_alt (новый ответ бэка = новый массив = новая запись кэша; WeakMap — без утечек); показанное
// название и пустые строки выпадают; null — названий на других языках нет
const _lowCache = new WeakMap()
export function gridSearchAlt_lows(item) {
    const alt = item && item.titles_alt
    if (!Array.isArray(alt) || !alt.length) return null
    let hit = _lowCache.get(alt)
    if (hit === undefined) {
        const title = String(item.title ?? '').trim().toLowerCase()
        hit = []
        for (const v of alt) {
            const s = typeof v === 'string' ? v.trim().toLowerCase() : ''
            if (s && s !== title && !hit.includes(s)) hit.push(s)
        }
        if (!hit.length) hit = null
        _lowCache.set(alt, hit)
    }
    return hit
}
// те же названия в исходном регистре (подсказка ячейки, подпись языка) — считается по требованию, без кэша; показанное название и повторы
// выпадают без учёта регистра (как у gridSearchAlt_lows), первое написание остаётся
export function gridSearchAlt_texts(item) {
    const alt = item && item.titles_alt
    if (!Array.isArray(alt) || !alt.length) return null
    const title = String(item.title ?? '').trim().toLowerCase()
    const out = [], seen = new Set()
    for (const v of alt) {
        const s = typeof v === 'string' ? v.trim() : '', low = s.toLowerCase()
        if (s && low !== title && !seen.has(low)) { seen.add(low); out.push(s) }
    }
    return out.length ? out : null
}

// вхождение части / фразы в текст на ступени tier (0 — точно), как check_CHIPS грида
const termIn = (low, term, tier) => (tier ? !!fuzzyFindTier(low, term, tier) : low.includes(term))
// ЯЧЕЙКА подпадает под чипс: фраза целиком в одном из названий, иначе ХОТЬ ОДНА часть в одном из названий (как подсветка найденных частей ячейки:
// остальные части могут быть в других ячейках строки). lows — gridSearchAlt_lows(item); terms — части в нижнем регистре
export function gridSearchAlt_hit(lows, terms, tier = 0, phrase = null) {
    if (!lows || !lows.length) return false
    if (phrase) return lows.some(x => !!phraseFind(x, phrase))
    if (!terms || !terms.length) return false
    return terms.some(term => lows.some(x => termIn(x, term, tier)))
}
// СТРОКА проходит чипс по названиям на других языках одной ячейки: все части в одном из названий (для проб и юнита; грид сам ведёт AND по строке
// через check_CHIPS — часть может быть найдена в показанном тексте другой ячейки)
export function gridSearchAlt_rowHit(lows, terms, tier = 0, phrase = null) {
    if (!lows || !lows.length) return false
    if (phrase) return lows.some(x => !!phraseFind(x, phrase))
    if (!terms || !terms.length) return false
    return lows.some(x => terms.every(term => termIn(x, term, tier)))
}
// совпавшее название ячейки в исходном регистре: первое из titles_alt, подпадающее под любое задание specs [{ terms, tier, phrase }] → { text, lang } | null
export function gridSearchAlt_matched(item, specs) {
    const texts = gridSearchAlt_texts(item)
    if (!texts || !specs || !specs.length) return null
    for (const text of texts) {
        const low = text.toLowerCase()
        for (const s of specs) {
            if (!s) continue
            const ok = s.phrase ? !!phraseFind(low, s.phrase) : (s.terms || []).some(term => termIn(low, term, s.tier || 0))
            if (ok) return { text, lang: gridSearchAlt_langOf(text) }
        }
    }
    return null
}

// ЛЕСТНИЦА ступени — тот же порядок, что у основной лестницы грида (gridSearchNav_recompute): 0) фраза целиком, 1) части как набрано, 2) части в другой
// раскладке клавиатуры, 3) ступени опечаток 1…6 — на каждой как набрано, затем другая раскладка. probe(terms, tier, phrase) → есть ли строка данных
// (грид: gridSearch_phraseExists(ph, alt=true) / gridSearch_hasTerms(terms, tier, alt=true)). Результат { title, tier, phrase } — текст чипса (сконвертированный
// при раскладке), ступень опечаток, режим фразы; null — служебный запрос («= …», «style:…», «>> …») либо ничего не нашлось
export function gridSearchAlt_ladder(query, probe, { maxTier = FUZZY_TIERS, layout = true, phrase = true } = {}) {
    const q = String(query ?? '').trim()
    if (!q || q.startsWith('=') || q.startsWith('style:') || q.startsWith('>> ')) return null
    const ph = phrase ? searchPhrase(q) : null
    if (ph && probe([], 0, ph)) return { title: q, tier: 0, phrase: true }
    const parts = searchTerms(q)
    if (!parts.length) return null
    if (probe(parts, 0, null)) return { title: q, tier: 0, phrase: false }
    const cands = layout ? layoutCandidates(q).map(c => ({ conv: c, terms: searchTerms(c) })).filter(c => c.terms.length) : []
    for (const c of cands) if (probe(c.terms, 0, null)) return { title: c.conv, tier: 0, phrase: false }
    const top = Math.min(maxTier | 0, Math.max(0, ...parts.map(fuzzyMaxTier), ...cands.map(c => Math.max(0, ...c.terms.map(fuzzyMaxTier)))))
    for (let tier = 1; tier <= top; tier++) {
        if (probe(parts, tier, null)) return { title: q, tier, phrase: false }
        for (const c of cands) if (probe(c.terms, tier, null)) return { title: c.conv, tier, phrase: false }
    }
    return null
}
// задание отбора / подсветки по решению лестницы: { terms, tier, phrase } (фраза — объект searchPhrase, части пусты)
export function gridSearchAlt_spec(dec) {
    if (!dec) return null
    const t0 = String(dec.title ?? '').trim()
    const ph = dec.phrase ? searchPhrase(t0) : null
    return { terms: ph ? [] : searchTerms(t0), tier: dec.tier || 0, phrase: ph }
}

// ЯЗЫК названия по письменности относительно ТЕКУЩЕГО языка интерфейса (titles_alt приходят без пометки языка): кириллица с і/ї/є/ґ — uk, с ы/э/ъ/ё — ru,
// без отличительных букв — другой кириллический язык, чем текущий (под en не различить → ''); латиница — en; '' — не распознан / совпадает с текущим
export function gridSearchAlt_langOf(text, cur = getLanguage()) {
    const s = String(text ?? '')
    if (RE_CYR.test(s)) {
        if (RE_UK.test(s)) return cur === 'uk' ? '' : 'uk'
        if (RE_RU.test(s)) return cur === 'ru' ? '' : 'ru'
        return cur === 'uk' ? 'ru' : (cur === 'ru' ? 'uk' : '')
    }
    if (RE_LAT.test(s)) return cur === 'en' ? '' : 'en'
    return ''
}
// язык совпавших названий для подписи чипса: один распознанный — он; разные либо нераспознанный — 'other'
export function gridSearchAlt_langs(texts, cur = getLanguage()) {
    const set = new Set()
    for (const x of texts || []) {
        set.add(gridSearchAlt_langOf(x, cur))
        if (set.size > 1) break
    }
    if (set.size === 1) { const l = [...set][0]; if (l) return l }
    return ALT_LANG_OTHER
}
// подписи (i18n): язык словами, подпись чипса, подсказка
export function gridSearchAlt_langName(lang) {
    const l = gridSearchAlt_shownLang(lang)   // IE 2026 09 28 / ODOO-341407: русский не называется — «another language»
    if (l === 'en') return t('English')
    if (l === 'uk') return t('Ukrainian')
    return t('another language')
}
export function gridSearchAlt_label(lang) {
    const l = gridSearchAlt_shownLang(lang)   // IE 2026 09 28 / ODOO-341407
    if (l === 'en') return t('Matches in English names')
    if (l === 'uk') return t('Matches in Ukrainian names')
    return t('Matches in other languages')   // IE 2026 09 28 / ODOO-341407: было «Matches in Russian names» / «Matches in other-language names»
}
export function gridSearchAlt_hint(lang) {
    return gridSearchAlt_label(lang) + ' — ' + t('nothing matches the displayed names; the rows are found by the names of the same records in another language')
}
